import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import { useForm } from 'react-hook-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import InvoiceType from '../models/InvoiceType';
import InvoiceDetail from '../models/InvoiceDetail';
import { FaTrash } from 'react-icons/fa';
import _ from 'lodash';

interface IInvoiceDetailsDialogProps {
    dialogName: string;
    handleConfirm?: (payload: Array<InvoiceDetail>, formData: Array<InvoiceDetail>) => void;
    deleteSelected?: (invoiceNumber: number, index: number) => void;
    hideDialog: () => void;
    invoiceNumber?: string;
    invoiceTypes?: Array<InvoiceType>;
    invoiceDetails?: Array<InvoiceDetail>;
}

const InvoiceDetailsDialog = (props: IInvoiceDetailsDialogProps) => {
    const { register, errors, getValues, formState, watch, setValue, reset } = useForm();
    const { isDirty, dirtyFields } = formState;
    const formInvoiceDetails = watch('invoiceDetails');
    const [invoiceDetails, setInvoiceDetails] = useState<Array<InvoiceDetail>>([]);
    const [invoiceDetailTypes, setInvoiceDetailTypes] = useState<Array<{ value: string; label: string }>>([]);

    useEffect(() => {
        if (Array.isArray(props.invoiceDetails) && props.invoiceDetails.length > 0) {
            setInvoiceDetails(props.invoiceDetails);
        }
    }, [props?.invoiceDetails]);

    useEffect(() => {
        if (Array.isArray(props.invoiceTypes) && props.invoiceTypes.length > 0) {
            setInvoiceDetailTypes(
                props.invoiceTypes.map(it => ({
                    value: it.documentType,
                    label: it.description,
                }))
            );
        }
    }, [props?.invoiceTypes]);

    useEffect(() => {
        if (!formInvoiceDetails || !Array.isArray(formInvoiceDetails) || formInvoiceDetails.length < 1) {
            return;
        }

        // Compute new amounts
        const newAmounts = formInvoiceDetails.map((row: InvoiceDetail) => {
            const quantity = Number(row.quantity) || 0;
            const rate = Number(row.rate) || 0;
            return quantity && rate ? quantity * rate : Number(row.amount) || 0;
        });

        // Update each amount without triggering loop
        newAmounts.forEach((amount: number, index: number) => {
            // only update if changed
            const currentAmount = Number(getValues(`invoiceDetails.${index}.amount`) || 0);
            if (currentAmount.toFixed(2) !== amount.toFixed(2)) {
                setValue(`invoiceDetails.${index}.amount`, amount.toFixed(2), { shouldDirty: true });
            }
        });

        // Update total
        const totalSum = newAmounts.reduce((sum: number, a: number) => sum + a, 0);
        setValue('total', totalSum.toFixed(2));
    }, [formInvoiceDetails, setValue]);

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('InvoiceDetailsDialog onCreate()');
    };

    const OKClicked = () => {
        const formData = getValues();
        if (formData?.invoiceDetails && Array.isArray(formData.invoiceDetails)) {
            const payload = formData.invoiceDetails;

            const dirtyInvoiceDetails = payload.filter((row, index) => {
                const dirtyRow = dirtyFields.invoiceDetails?.[index];
                // include this row if dirtyRow exists and has at least one key
                return dirtyRow && Object.keys(dirtyRow).length > 0;
            });

            props.handleConfirm(dirtyInvoiceDetails, payload as Array<InvoiceDetail>);
            reset(getValues());
            // props.hideDialog();
        } else {
            alert('No changes');
        }
    };

    const handleSubmit = (formData: object) => {
        const formData2 = getValues();
        console.log(formData && formData2);
    };

    const addNewRow = () => {
        const newRow = new InvoiceDetail();
        const newInvoiceDetails = _.cloneDeep(invoiceDetails);
        newInvoiceDetails.push(newRow);
        setInvoiceDetails(newInvoiceDetails);
    };

    const getInitialTotal = () => {
        return (props?.invoiceDetails ?? [])
            .reduce((sum, d) => sum + Number(d.amount ?? 0), 0).toFixed(2);
    };

    const formatMoney = (value: number): string => value.toFixed(2);

    return (
        <Dialog title="Invoice Details" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '60vw' }}>
            <div style={{ display: 'flex', justifyContent: 'left', width: '100%'}}>
                <form style={{width: '100%'}} onSubmit={handleSubmit}>                
                    <table className={'project-billing'}>
                        <thead className={'project-billing'} style={{backgroundColor: '#00000000', textAlign: 'center' }}>
                            <tr style={{overflow: 'hidden'}} className={'project-billing'}>
                                <th className="find-person-header" style={{ width: '10%' }}>Type</th>
                                <th className="find-person-header" style={{ width: '20%' }}>Description</th>
                                <th className="find-person-header" style={{ width: '5%' }}>Quantity</th>
                                <th className="find-person-header" style={{ width: '5%' }}>Code</th>
                                <th className="find-person-header" style={{ width: '5%' }}>LF</th>
                                <th className="find-person-header" style={{ width: '5%' }}>Rate</th>
                                <th className="find-person-header" style={{ width: '6%' }}>Amount</th>
                                <th className="find-person-header" style={{ width: '2%' }}/>
                            </tr>
                        </thead>
                        <tbody className={'project-billing'} style={{width: '100%', maxHeight: '60vh', overflowY: 'scroll'}}>
                                {invoiceDetails && invoiceDetails.map((id, index) => {
                                 return (<tr key={index + id.invNumber}>
                                    <td style={{width: '0%'}}>
                                        <RHFInputBox
                                            register={register}
                                            type={'text'}
                                            style={{height: '0%', width: '0%'}}
                                            bodyStyle={{height: '0%', width: '0%'}}
                                            name={`invoiceDetails.${index}.orderNumber`}
                                            defaultVal={id?.orderNumber ? id.orderNumber.toString() : ''}
                                        />
                                    </td>
                                    <td style={{width: '10%'}}>
                                        <RHFSelect
                                            register={register}
                                            style={{width: '100%'}}
                                            bodyStyle={{width: '100%'}}
                                            defaultVal={id?.type}
                                            errors={errors}
                                            name={`invoiceDetails.${index}.type`}
                                            options={!!invoiceDetailTypes ? invoiceDetailTypes : [
                                                {value: 1, label: 'Service'},
                                                {value: 1, label: 'Backup'},
                                                {value: 1, label: 'Expense'},
                                                {value: 1, label: 'Office'},
                                                {value: 1, label: 'Discount'},
                                                {value: 1, label: 'Field Equipment'}
                                            ]}
                                        />
                                    </td>
                                    <td style={{width: '20%'}}>
                                        <RHFInputBox
                                            name={`invoiceDetails.${index}.description`}
                                            defaultVal={id.description}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{width: '5%'}}>
                                        <RHFInputBox
                                            name={`invoiceDetails.${index}.quantity`}
                                            defaultVal={id?.quantity ? id.quantity.toFixed(4) : ''}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{width: '5%'}}>
                                        <RHFInputBox
                                            name={`invoiceDetails.${index}.code`}
                                            defaultVal={id?.code ? id.code : ''}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{width: '5%'}}>
                                        <RHFInputBox
                                            name={`invoiceDetails.${index}.lineFormat`}
                                            defaultVal={id?.lineFormat ? id.lineFormat : ''}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{width: '5%'}}>
                                        <RHFInputBox
                                            name={`invoiceDetails.${index}.rate`}
                                            defaultVal={id?.rate ? id.rate.toString() : ''}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{width: '6%'}}>
                                        <RHFInputBox
                                            name={`invoiceDetails.${index}.amount`}
                                            defaultVal={id?.amount ? id.amount.toFixed(2) : ''}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                            readOnly={!id?.quantity && !id?.rate ? false : true}
                                        />
                                    </td>
                                    <td style={{width: '2%'}}>
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Delete"
                                            reactIcon={FaTrash}
                                            iconHoverColor="blue"
                                            iconStyle={{fill: 'red', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => props?.deleteSelected(props?.invoiceDetails[index].invNumber,
                                                props?.invoiceDetails[index].orderNumber)
                                            }
                                        />
                                    </td>
                                </tr>);
                            })}
                        </tbody>                        
                    </table>
                    <div className="form-row" style={{marginTop: '2rem', display: 'flex', justifyContent: 'space-evenly'}}>
                        <div style={{width: '50%', display: 'flex', justifyContent: 'flex-start'}}>
                            <Button
                                className="blue-hover-button"
                                style={{whiteSpace: 'nowrap', width: '15%', marginRight: '1rem' }}
                                text={'Add New'}
                                onClick={() => addNewRow()}
                            />
                            <Button
                                className="blue-hover-button"
                                style={{whiteSpace: 'nowrap', width: isDirty ? '25%' : '10%', marginRight: '1rem' }}
                                text={isDirty ? 'Save Changes' : 'OK'}
                                onClick={() => OKClicked()}
                            />
                            <Button
                                className="blue-hover-button"
                                style={{ width: '13%' }}
                                text={'Cancel'}
                                onClick={() => props.hideDialog()}
                            />
                        </div>
                        <div style={{width: '50%', display: 'flex', justifyContent: 'flex-end'}}>
                            <RHFInputBox
                                name={`total`}
                                labelOnLeft={true}
                                label={'Total:'}
                                defaultVal={formatMoney(Number(getInitialTotal()))}
                                type="text"
                                register={register}
                                errors={errors}
                                style={{ width: '100%' }}
                                bodyStyle={{ width: '29%' }}
                                readOnly={true}
                            />
                        </div>
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default InvoiceDetailsDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/InvoiceDetailsDialog.tsx